import { styled, theme } from '../../config/Theme';

export default styled.div`
  width: calc(100% - ${theme.space.small} * 2);
  padding-bottom: ${(props) => props.theme.space.large} * 2;
  flex: 1 0 auto;
`;
